import { render, staticRenderFns } from "./CompetitionsViewTimelineCard.vue?vue&type=template&id=ef0772dc&scoped=true&"
import script from "./CompetitionsViewTimelineCard.vue?vue&type=script&lang=js&"
export * from "./CompetitionsViewTimelineCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0772dc",
  null
  
)

export default component.exports